import React from 'react';
import MessageBubble from './toolkit-chatbot-panel-message-bubble';
import { DOC_INDEXING_STATUS, MAX_RETRY_COUNT } from './toolkit-chatbot-utils';
import { FormattedMessage } from 'react-intl';
import ErrorNotification from 'components/util/error-notification-component';

const ChatWindow = ({
  BLOCK,
  messages,
  setMessages,
  currentUser,
  containerCode,
  cbFeedbackEnabled,
  isIndexingCompleted,
  geoCode,
  documentIndexingData,
  handleRetryClick,
}) => {
  return (
    <>
      {!isIndexingCompleted ? (
        <div className={`${BLOCK}__chat-not-available-message`}>
          {documentIndexingData &&
          documentIndexingData.status === DOC_INDEXING_STATUS.IN_PROGRESS ? (
            <FormattedMessage
              id={'statement-chatbot-indexing-inprogress-message'}
            />
          ) : documentIndexingData &&
            documentIndexingData.retryCount >= MAX_RETRY_COUNT ? (
            <ErrorNotification errorMessage="statement-chatbot-unavailable-message" />
          ) : (
            <FormattedMessage
              id={'chatbot-body.indexing.incomplete.message'}
              values={{
                retry: (
                  <span
                    onClick={handleRetryClick}
                    style={{ color: 'blue', cursor: 'pointer' }}
                  >
                    <FormattedMessage
                      id={'statement-chatbot-re-index-retry-button'}
                    />
                  </span>
                ),
              }}
            />
          )}
        </div>
      ) : (
        <div className={`${BLOCK}__chat-window`}>
          {messages.map((message) => (
            <MessageBubble
              key={message.id}
              message={message}
              BLOCK={BLOCK}
              setMessages={setMessages}
              currentUser={currentUser}
              containerCode={containerCode}
              cbFeedbackEnabled={cbFeedbackEnabled}
              geoCode={geoCode}
            />
          ))}
        </div>
      )}
    </>
  );
};

export default ChatWindow;
